const months = [...document.querySelectorAll('[data-month]')];
const productionFilter = document.querySelector('#filter-production');
const monthFilter = document.querySelector('#filter-month');
const dayFilter = document.querySelector('#filter-day');
const theatreFilter = document.querySelector('#filter-theatre');
const tourFilter = document.querySelector('#filter-tour');
const performances = document.querySelectorAll('.performance');

if (monthFilter && months) {
	months.map((month, index) => {
		const option = document.createElement('option');
		option.value = month.dataset.month;
		option.innerHTML = month.dataset.month;
		monthFilter.append(option);
	});
}

if (productionFilter) {
	productionFilter.value = '';
	productionFilter.addEventListener('change', function () {
		filterPerformances('production');
	});
}

if (monthFilter) {
	dayFilter.disabled = true;
	monthFilter.addEventListener('change', function () {
		filterPerformances('month');
	});
}

if (dayFilter) {
	dayFilter.addEventListener('change', function () {
		filterPerformances('day');
	});
}

if (theatreFilter) {
	theatreFilter.addEventListener('change', function () {
		filterPerformances('theatre');
	});
}

if (tourFilter) {
	tourFilter.addEventListener('change', function () {
		filterPerformances('tour');
	});
}

function filterPerformances(filterType) {
	if (filterType !== 'day') {
		dayFilter.value = '';
	}

	const production = productionFilter ? productionFilter.value : '';
	const month = monthFilter.value;
	const day = dayFilter.value;
	const theatre = theatreFilter.checked;
	const tour = tourFilter.checked;

	const productionMonths = [];

	performances.forEach(function (element) {
		let productionMatch = false;
		let monthMatch = false;
		let dayMatch = false;
		let theatreMatch = false;
		let tourMatch = false;
		if (production === '' || element.getAttribute('data-production') === production) {
			productionMatch = true;
		}
		if (month === '' || element.getAttribute('data-perfMonth') === month) {
			monthMatch = true;
		}
		if (day === '' || element.getAttribute('data-day') === day) {
			dayMatch = true;
		}
		if (theatre && theatreFilter.value === element.getAttribute('data-perfType')) {
			theatreMatch = true;
		}
		if (tour && tourFilter.value === element.getAttribute('data-perfType')) {
			tourMatch = true;
		}
		if (productionMatch && monthMatch && dayMatch && (theatreMatch || tourMatch)) {
			element.classList.remove('hidden');
			productionMonths.push(element.getAttribute('data-perfMonth'));
			return;
		}
		element.classList.add('hidden');
	});

	const uniqMonths = [...new Set(productionMonths)];

	if (months) {
		months.forEach(function (element) {
			if (!uniqMonths.includes(element.getAttribute('data-month'))) {
				element.classList.add('hidden');
				return;
			}
			element.classList.remove('hidden');
		});
	}

	if (month !== '') {
		checkForDays(filterType);
	} else {
		dayFilter.disabled = true;
	}
}

function checkForDays(filterType) {
	if (filterType === 'day') return;
	const days = [];
	performances.forEach(function (element) {
		if (element.classList.contains('hidden')) {
			return;
		}
		days.push(element.getAttribute('data-day'));
		dayFilter.disabled = false;
	});

	const uniqDays = [...new Set(days)];

	if (dayFilter) {
		dayFilter.length = 1;
		uniqDays.map((day, index) => {
			const option = document.createElement('option');
			option.value = day;
			option.innerHTML = day;
			dayFilter.append(option);
		});
	}
}
